import React, { useState } from 'react'
import PropTypes from 'prop-types'
import MoreIcon from '@material-ui/icons/MoreVert'
import {
  Menu,
  MenuItem,
  IconButton,
} from '@material-ui/core'


const Options = ({
  items,
  children,
  className,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const handleClose = () => setAnchorEl(null)
  const handleClick = e => setAnchorEl(e.currentTarget)
  const handleClickItem = item => (e) => {
    handleClose()
    if (item.onClick) {
      item.onClick(e)
    }
  }

  return (
    <>
      <IconButton className={className} onClick={handleClick}><MoreIcon /></IconButton>
      <Menu
        anchorEl={anchorEl}
        onClose={handleClose}
        open={Boolean(anchorEl)}
      >
        {items.map((item => <MenuItem onClick={handleClickItem(item)}>{item.label}</MenuItem>))}
        {children}
      </Menu>
    </>
  )
}


Options.defaultProps = {
  items: [],
}


Options.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
}


export default Options